import React from "react";
import { RequirePermission } from "./RequirePermission";

export function RequireDeveloper({ children }: { children: React.ReactNode }) {
  return (
    <RequirePermission moduleId="developerPortal" level="view" message="This area requires developer portal access.">
      {children}
    </RequirePermission>
  );
}
